$(document).ready(function() {
  // Function to populate subcategories based on the selected category
  function populateSubCategories(categoryId, selectedSubCategoryId, callback) {
    var subcategorySelect = $('#message-sub-category-select');
    var submorecategorySelect = $('#message-sub-more-category-select');
    
    if (categoryId) {
      $.ajax({
        url: '/content_hubs/get_sub_categories',
        type: 'GET',
        data: { id: categoryId },
        dataType: 'json',
        cache: false,
        success: function(data) {
          subcategorySelect.empty();
          subcategorySelect.append('<option value ="">-Select-</option>');
          $.each(data, function(index, subcategory) {
            subcategorySelect.append('<option value="' + subcategory.id + '">' + subcategory.title + '</option>');
          });
          if (selectedSubCategoryId) {
            subcategorySelect.val(selectedSubCategoryId);
            if (callback) callback(selectedSubCategoryId);
          } else {
            subcategorySelect.val('');
            submorecategorySelect.empty();
            submorecategorySelect.append('<option value ="">-Select-</option>');
          }
        }
      });
    } else {
      subcategorySelect.empty();
      subcategorySelect.append('<option value ="">-Select-</option>');
      submorecategorySelect.empty();
      submorecategorySelect.append('<option value ="">-Select-</option>');
    }
  }

  // Function to populate sub-more categories based on the selected subcategory
  function populateSubMoreCategories(subcategoryId, selectedSubMoreCategoryId) {
    var submorecategorySelect = $('#message-sub-more-category-select');
    
    if (subcategoryId) {
      $.ajax({
        url: '/content_hubs/get_sub_more_categories',
        type: 'GET',
        data: { id: subcategoryId },
        dataType: 'json',
        cache: false,
        success: function(data) {
          submorecategorySelect.empty();
          submorecategorySelect.append('<option value ="">-Select-</option>');
          $.each(data, function(index, submorecategory) {
            submorecategorySelect.append('<option value="' + submorecategory.id + '">' + submorecategory.title + '</option>');
          });
          if (selectedSubMoreCategoryId) {
            submorecategorySelect.val(selectedSubMoreCategoryId);
          } else {
            submorecategorySelect.val('');
          }
        }
      });
    } else {
      submorecategorySelect.empty();
      submorecategorySelect.append('<option value ="">-Select-</option>');
    }
  }

  // On category change, fetch and populate subcategories
  $(document).on('change', '#message-category-select', function() {
    var categoryId = $(this).val();
    populateSubCategories(categoryId, null, null);
  });

  // On subcategory change, fetch and populate sub-more categories
  $(document).on('change', '#message-sub-category-select', function() {
    var subcategoryId = $(this).val();
    populateSubMoreCategories(subcategoryId, null);
  });

  // Initial population on page load for edit form
  var initialCategoryId = $('#message-category-select').val();
  var initialSubCategoryId = $('#message-sub-category-select').data('selected');
  var initialSubMoreCategoryId = $('#message-sub-more-category-select').data('selected');

  if (initialCategoryId) {
    populateSubCategories(initialCategoryId, initialSubCategoryId, function(subcategoryId) {
      if (initialSubMoreCategoryId) {
        populateSubMoreCategories(subcategoryId, initialSubMoreCategoryId);
      }
    });
  }
});
